export default "__VITE_ASSET__70e2a897__"